import React, { useEffect, useState, Component } from 'react';
import { LocalMarketing } from './pages/LocalMarketing';
import { GoogleMapsScraper } from './pages/GoogleMapsScraper';
import { LocalBusinessDatabase } from './pages/LocalBusinessDatabase';
import { LocalBusinessEnrichment } from './pages/LocalBusinessEnrichment';
import { OwnerFinder } from './pages/OwnerFinder';
import { EmailSequencing } from './pages/EmailSequencing';
import { AccountingDatabase } from './pages/AccountingDatabase';
import { AccountingNYC } from './pages/AccountingNYC';
import { DataDirectory } from './pages/DataDirectory';
import { EcommerceDatabase } from './pages/EcommerceDatabase';
import { Features } from './pages/Features';
import { Landing } from './pages/Landing';
import { OpenclawForSales } from './pages/OpenclawForSales';
// Original page components
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { AlternativeSection } from './components/AlternativeSection';
import { ApiPlayground } from './components/ApiPlayground';
import { ComparisonTable } from './components/ComparisonTable';
import { FieldCoverage } from './components/FieldCoverage';
import { PricingValue } from './components/PricingValue';
import { UseCases } from './components/UseCases';
import { FAQ } from './components/FAQ';
import { RelatedFeatures } from './components/RelatedFeatures';
import { CtaBanner } from './components/CtaBanner';
import { Footer } from './components/Footer';
class ErrorBoundary extends Component<{
  children: React.ReactNode;
}, {
  hasError: boolean;
  error: Error | null;
}> {
  constructor(props: {
    children: React.ReactNode;
  }) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }
  static getDerivedStateFromError(error: Error) {
    return {
      hasError: true,
      error
    };
  }
  render() {
    if (this.state.hasError) {
      return <div style={{
        padding: 40,
        fontFamily: 'monospace'
      }} data-id="element-0">
          <h1 style={{
          color: 'red'
        }} data-id="element-1">
            Something went wrong
          </h1>
          <pre style={{
          whiteSpace: 'pre-wrap',
          marginTop: 16
        }} data-id="element-2">
            {this.state.error?.message}
          </pre>
          <pre style={{
          whiteSpace: 'pre-wrap',
          marginTop: 8,
          fontSize: 12,
          color: '#666'
        }} data-id="element-3">
            {this.state.error?.stack}
          </pre>
        </div>;
    }
    return this.props.children;
  }
}
function LocalBusinessAPI() {
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-blue-100 selection:text-blue-900" data-id="element-4">
      <Navbar data-id="element-5" />
      <main data-id="element-6">
        <HeroSection data-id="element-7" />
        <TrustBar data-id="element-8" />
        <FieldCoverage data-id="element-9" />
        <AlternativeSection data-id="element-10" />
        <ApiPlayground data-id="element-11" />
        <ComparisonTable data-id="element-12" />
        <PricingValue data-id="element-13" />
        <UseCases data-id="element-14" />
        <FAQ data-id="element-15" />
        <RelatedFeatures data-id="element-16" />
        <CtaBanner data-id="element-17" />
      </main>
      <Footer data-id="element-18" />
    </div>;
}
export function App() {
  const [currentPath, setCurrentPath] = useState(window.location.hash || '#/');
  useEffect(() => {
    const onHashChange = () => {
      setCurrentPath(window.location.hash || '#/');
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);
  const renderPage = () => {
    switch (currentPath) {
      case '#/':
        return <Landing data-id="element-19" />;
      case '#/features':
        return <Features data-id="element-20" />;
      case '#/local-business-api':
        return <LocalBusinessAPI data-id="element-21" />;
      case '#/google-maps-scraper':
        return <GoogleMapsScraper data-id="element-22" />;
      case '#/local-business-database':
        return <LocalBusinessDatabase data-id="element-23" />;
      case '#/local-business-enrichment':
        return <LocalBusinessEnrichment data-id="element-24" />;
      case '#/owner-finder':
        return <OwnerFinder data-id="element-25" />;
      case '#/email-sequencing':
        return <EmailSequencing data-id="element-26" />;
      case '#/local-marketing':
        return <LocalMarketing data-id="element-27" />;
      case '#/ecommerce-database':
        return <EcommerceDatabase data-id="element-28" />;
      case '#/data':
        return <DataDirectory data-id="element-29" />;
      case '#/data/accounting':
        return <AccountingDatabase data-id="element-30" />;
      case '#/data/accounting-new-york-city':
        return <AccountingNYC data-id="element-31" />;
      case '#/openclaw-for-sales':
        return <OpenclawForSales data-id="element-32" />;
      default:
        return <Landing data-id="element-33" />;
    }
  };
  return <ErrorBoundary data-id="element-34">{renderPage()}</ErrorBoundary>;
}